import ContextProvider from 'common/contexts/crud';
import React, { createContext, useContext } from 'react';

const ProjectsContext = createContext();
const useProjects = () => useContext(ProjectsContext);

export const ProjectsProvider = (props) => <ContextProvider url="projects" context={ProjectsContext} {...props} />;

export default useProjects;
